// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"4b92c5eef9fe09f9451c","454":"008c180e948316d6ee91"}[chunkId] + ".js";
};